import { useEffect } from 'react';

import { DataProviderQueryStatus } from '../../DataProvider/types';
import { useChart } from '../ChartProvider';
import { usePageExport } from './PageExportProvider';

export const useChartLoadingStatus = (
  status: DataProviderQueryStatus
): void => {
  const { item } = useChart();
  const { updateChartLoadingState } = usePageExport();
  const chartId = item?.id;

  useEffect(() => {
    if (!chartId) return;

    const isLoading =
      status === DataProviderQueryStatus.Idle ||
      status === DataProviderQueryStatus.Fetching;

    updateChartLoadingState(chartId, isLoading);
  }, [chartId, status, updateChartLoadingState]);
};
